import { Link, useLocation } from 'react-router-dom';
import {
  Sidebar,
  NavBrand,
  NavGroup,
  NavItem,
  NavSpacer,
  Avatar,
  Button,
} from '@kollektive/design-system';
import {
  LayoutDashboard,
  Key,
  Database,
  Users,
  LogOut,
} from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { useTenant } from '@/hooks/useTenant';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import styles from './AppSidebar.module.css';

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, adminOnly: false },
  { path: '/tokens', label: 'MCP Tokens', icon: Key, adminOnly: false },
  { path: '/connections', label: 'Connections', icon: Database, adminOnly: false },
  { path: '/team', label: 'Team', icon: Users, adminOnly: true },
];

export function AppSidebar() {
  const location = useLocation();
  const { user, signOut } = useAuth();
  const { tenant } = useTenant();
  const { canManageTeam } = useCurrentUser();

  // Filter nav items based on user permissions
  const visibleNavItems = navItems.filter(item => !item.adminOnly || canManageTeam);

  const handleSignOut = async () => {
    await signOut();
  };

  // Get user display info
  const userEmail = user?.email ?? '';
  const userName = user?.user_metadata?.full_name ?? user?.user_metadata?.name ?? userEmail.split('@')[0];

  return (
    <Sidebar className={styles.sidebar}>
      {/* Brand */}
      <NavBrand
        logo={tenant?.logoUrl ? <img src={tenant.logoUrl} alt="" className={styles.logo} /> : undefined}
        name={tenant?.name ?? 'Kollektive'}
      />

      {/* Main navigation */}
      <NavGroup>
        {visibleNavItems.map(({ path, label, icon: Icon }) => (
          <NavItem
            key={path}
            as={Link}
            to={path}
            active={location.pathname === path}
            icon={<Icon size={20} />}
          >
            {label}
          </NavItem>
        ))}
      </NavGroup>

      <NavSpacer />

      {/* User section */}
      <div className={styles.userSection}>
        <div className={styles.userInfo}>
          <Avatar name={userName} size="sm" />
          <div className={styles.userDetails}>
            <span className={styles.userName}>{userName}</span>
            <span className={styles.userEmail}>{userEmail}</span>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleSignOut}
          className={styles.signOutButton}
          title="Sign out"
        >
          <LogOut size={18} />
        </Button>
      </div>
    </Sidebar>
  );
}
